import React, { useEffect, useState, useContext } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { observer } from "mobx-react-lite";
import { Context } from "../..";
import { Applicant, FormField } from "../../models/General";

const EditProfilePage: React.FC = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm<Applicant>();
  const { store } = useContext(Context);
  const [formFields, setFormFields] = useState<FormField[]>([]);

  useEffect(() => {
    async function loadOptions() {
      await store.getDegreesOptions();
      await store.getRankOptions();

      setFormFields([
        { label: 'Прізвище', name: 'surname', type: 'text' },
        { label: 'Ім`я', name: 'name', type: 'text' },
        { label: 'По-батькові', name: 'middle_name', type: 'text' },
        { label: 'Дата народження', name: 'date_of_birth', type: 'date' },
        { label: 'Навчальний заклад', name: 'institution', type: 'text' },
        { label: 'Освіта', name: 'education', type: 'text' },
        { label: 'Кваліфікація', name: 'qualification', type: 'text' },
        { label: 'Наукове звання', name: 'academic_rank', type: 'select', options: store.rankOptions },
        { label: 'Науковий ступінь', name: 'academic_degree', type: 'select', options: store.degreesOptions },
        { label: 'Рік випуску', name: 'year_graduation', type: 'text' },
        { label: 'Місце роботи', name: 'workplace', type: 'text' },
        { label: 'Посада', name: 'position', type: 'text' },
        { label: 'Робочий телефон', name: 'work_phone', type: 'tel' },
        { label: 'Мобільний телефон', name: 'mobile_phone', type: 'tel' },
      ]);

      reset(store.applicant);
    }

    loadOptions();
  }, [store, reset]);

  const onSubmit: SubmitHandler<Applicant> = data => {
    store.updateUser(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="editProfile__form">
      {formFields.map(({ label, name, type, options }) => (
        <div key={name} className="editProfile__fieldGroup">
          <label className="editProfile__label">{label}:</label>
          {type !== 'select' ? (
            <input
              type={type}
              defaultValue={(store.applicant[name] || '').toString()} // Fix: Convert defaultValue to string
              {...register(name)}
              className="editProfile__input"
            />
          ) : (
            <select {...register(name)} className="editProfile__input" defaultValue={(store.applicant[name] || '').toString()}>
              {options?.map(option => (
                <option key={option.name} value={option.name}>{option.localization}</option>
              ))}
            </select>
          )}
          {errors[name] && <p className="error-message">{errors[name]?.message}</p>}
        </div>
      ))}
      <button type="submit" className="editProfile__button">Зберегти</button>
    </form>
  );
};

export default observer(EditProfilePage);
